import { ResourceGlobalConfig } from '@ark7/resource2';

import { environment } from '../environments/environment';

ResourceGlobalConfig.pathPrefix = environment.apiHost;
